import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import { useDispatch } from "react-redux";
import React, { useContext, useEffect, useState } from "react";
import DriveState from "./context/driveState";
import Main from "./mainDrive";
import DriveContext from "./context/driveContext";
import MediaPage from "./media";
import accessCheckPromise from "../../../../utils/accessCheck";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import AuthorizationError from "../AuthorizationError";

const Index = () => {
  return (
    // <Main />
    <DriveState>
      <DriveContent />
    </DriveState>
  );
};
const DriveContent = () => {
  const { currentPage } = useContext(DriveContext);
  const dispatch = useDispatch();
  const [access, setAccess] = useState(false);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  if (!access) {
    return <AuthorizationError />;
  }

  return (
    <>
      {currentPage == "albums" && <Main />}
      {currentPage == "mediaPage" && <MediaPage />}
    </>
  );
};
export default Index;
